import { render, staticRenderFns } from "./plate-type.vue?vue&type=template&id=08e1d5cd&scoped=true&"
import script from "./plate-type.vue?vue&type=script&lang=js&"
export * from "./plate-type.vue?vue&type=script&lang=js&"
import style0 from "./plate-type.vue?vue&type=style&index=0&id=08e1d5cd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e1d5cd",
  null
  
)

export default component.exports